<template>
    <el-container>
        <el-header>

        </el-header>
        <el-main>
            <el-row>
                <el-col :span="12">
                    <div class="grid-content bg-purple" style="display: flex;">
                        <el-input placeholder="请输入计划名" v-model="input" style="width: 250px;" clearable></el-input>
                        <div style="margin-left: 10px;"><el-button type="primary" plain @click="selectdxb">查询</el-button>
                        </div>
                        <div style=""><el-button type="primary" plain @click="opendialog">新增新计划</el-button>
                        </div>
                        <div style=""><el-button type="primary" plain @click="downloadTemplate">下载excel模板</el-button>
                        </div>
                    </div>
                </el-col>

                <el-col :span="4">


                </el-col>
                <el-col :span="8">
                </el-col>
            </el-row>


            <el-table ref="multipleTable" :data="dingxiangbaoData" stripe style="width: 100%; margin-top: 30px;"
                @selection-change="handleSelectionChange">

                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="name" label="计划名"></el-table-column>
                <el-table-column label="开关状态">
                    <template slot-scope="scope">
                        <span :class="scope.row.status ? 'status-open' : 'status-close'">
                            {{ scope.row.status ? "开" : "关" }}
                        </span>
                    </template>
                </el-table-column>


                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="editdxbao(scope.row)" plain icon="el-icon-edit">修改</el-button>

                        <el-popconfirm title="确定删除吗？" confirm-button-text="确定" cancel-button-text="取消" icon="el-icon-info"
                            icon-color="red" @confirm="deletedxb(scope.row)">
                            <el-button slot="reference" type="danger" icon="el-icon-delete" plain>删除</el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="pageNum" :page-size="pageSize"
                layout="prev, pager, next, jumper" :total="total">
            </el-pagination>
        </el-main>
        <el-dialog title="编辑计划" :visible.sync="creativeMaterialsedit" width="1260px" :close-on-click-modal="false"
            append-to-body @close="closebiaodan">
            <div class="m-header" style="height: 550px;overflow-y: auto;">
                <el-form :model="form2" label-position="right" class="demo-ruleForm" style="display: flex;">
                    <!-- <div data-v-da9757c6="" class="adgroup-item2">编辑计划</div> -->
                    <el-form-item label="计划名" prop="pkgname" label-width="82px">
                        <el-input v-model="form2.name" style="width: 300px;" placeholder="请输入计划名" clearable></el-input>
                    </el-form-item>

                    <el-form-item label="开关状态" prop="status" label-width="82px">
                        <el-switch v-model="form2.status" :active-value="1" :inactive-value="0" active-color="#13ce66"
                            @change="swtichonchange2" inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>
                    <el-form-item label="子账户名称" prop="apiid" label-width="152px">
                        <el-select v-model="form2.monitoruserid" placeholder="请选择" style="width: 200px">
                            <el-option v-for="item in form2.monitoruseridlist" :key="item.value" :label="item.dlsname"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="apiid" label-width="52px">
                        <el-button type="success" @click="addTaskRow" :disabled="disabledstatus">新增任务</el-button>
                    </el-form-item>
                    <el-form-item prop="apiid" label-width="52px">
                        <el-button type="primary" icon="el-icon-upload" plain @click="editexcelopenDialog">批量导入</el-button>
                    </el-form-item>
                </el-form>
                <el-table :data="form2.tasklist" border stripe height="500" class="account-table" v-loading="taskLoading"
                    empty-text="暂无账户数据，请添加或导入">


                    <el-table-column label="最小金额" min-width="150">
                        <template v-slot="scope">
                            <el-input v-model="scope.row.minconsume" placeholder="请输入账户最小金额"
                                @blur="checkOverlap(scope.$index)" />
                        </template>
                    </el-table-column>

                    <el-table-column label="最大金额" min-width="150">
                        <template v-slot="scope">
                            <el-input v-model="scope.row.maxconsume" placeholder="请输入账户最大金额"
                                @blur="checkOverlap(scope.$index)" />
                        </template>
                    </el-table-column>

                    <el-table-column label="账户DP" min-width="150">
                        <template v-slot="scope">
                            <el-input v-model="scope.row.deeplink" @blur="editdpcheckOverlap(scope.$index)"
                                placeholder="请输入账户DP" />
                        </template>
                    </el-table-column>

                    <el-table-column label="操作" width="80" fixed="right">
                        <template v-slot="scope">
                            <el-button type="danger" icon="el-icon-delete" circle size="mini"
                                @click="removeAccountRow(scope.$index, scope.row)" />
                        </template>
                    </el-table-column>

                </el-table>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="creativeMaterialsedit = false">取 消</el-button>
                <el-button type="primary" @click="postdingxiang2">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="新建计划" :visible.sync="creativeMaterials" width="1360px">

            <el-form :model="form" label-position="right" class="demo-ruleForm" style="display: flex;">
                <el-form-item label="计划名" prop="pkgname" label-width="82px">
                    <el-input v-model="form.name" style="width: 300px;" placeholder="请输入计划名" clearable></el-input>
                </el-form-item>

                <el-form-item label="开关状态" prop="status" label-width="82px">
                    <el-switch v-model="form.status" :active-value="1" :inactive-value="0" :disabled="!form.monitoruserid"
                        active-color="#13ce66" inactive-color="#ff4949" @change="switchonchange" />
                </el-form-item>
                <el-form-item label="子账户名称" prop="apiid" label-width="152px">
                    <el-select v-model="form.monitoruserid" placeholder="请选择" style="width: 200px">
                        <el-option v-for="item in form.monitoruseridlist" :key="item.value" :label="item.dlsname"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="apiid" label-width="52px" style="margin-left: 20px;">
                    <el-button type="success" @click="newplanaddTaskRow" :disabled="disabledstatus">新增任务</el-button>

                </el-form-item>
                <el-form-item prop="apiid" label-width="52px">
                    <el-button type="primary" icon="el-icon-upload" plain @click="excelopenDialog">批量导入</el-button>
                </el-form-item>

            </el-form>
            <el-table :data="form.tasklist" border stripe height="500" class="account-table" v-loading="taskLoadingnewplan"
                empty-text="暂无账户数据，请添加或导入">


                <el-table-column label="最小金额" min-width="150">
                    <template v-slot="scope">
                        <el-input v-model="scope.row.minconsume" placeholder="请输入账户最小金额"
                            @blur="newplancheckOverlap(scope.$index)" />
                    </template>
                </el-table-column>

                <el-table-column label="最大金额" min-width="150">
                    <template v-slot="scope">
                        <el-input v-model="scope.row.maxconsume" placeholder="请输入账户最大金额"
                            @blur="newplancheckOverlap(scope.$index)" />
                    </template>
                </el-table-column>

                <el-table-column label="账户DP" min-width="150">
                    <template v-slot="scope">
                        <el-input v-model="scope.row.deeplink" placeholder="请输入账户DP" />
                    </template>
                </el-table-column>

                <el-table-column label="操作" width="80" fixed="right">
                    <template v-slot="scope">
                        <el-button type="danger" icon="el-icon-delete" circle size="mini"
                            @click="newplanremoveAccountRow(scope.$index, scope.row)" />
                    </template>
                </el-table-column>

            </el-table>

            <span slot="footer" class="dialog-footer">
                <el-button @click="creativeMaterials = false">取 消</el-button>
                <el-button type="primary" @click="submitImport">
                    确 定
                </el-button>
            </span>
        </el-dialog>
        <el-dialog title="批量导入" :visible.sync="exceldialogVisible" width="50%">


            <!-- 文件上传组件 -->
            <el-upload class="upload-demo" :auto-upload="false" action="#" :on-change="handleFileChange"
                :show-file-list="false" accept=".xlsx,.xls,.csv" drag>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将Excel文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">
                    只能上传xlsx/xls文件，且必须包含以下列：<br>
                    dlsname(代理商名称), dlsownerid, dlsapiid, dlsapikey, zownerid
                </div>
            </el-upload>

            <!-- 预览表格 -->
            <el-table v-if="importData.length > 0" :data="importData" border style="width: 100%; margin-top: 20px;">
                <el-table-column prop="minconsume" label="最小金额"></el-table-column>
                <el-table-column prop="maxconsume" label="最大金额"></el-table-column>
                <el-table-column prop="deeplink" label="账户DP"></el-table-column>

            </el-table>

            <span slot="footer" class="dialog-footer">
                <el-button @click="exceldialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitImportform" :disabled="importData.length === 0">
                    确 定 (已导入 {{ importData.length }} 条数据)
                </el-button>
            </span>
        </el-dialog>
        <el-dialog title="批量导入" :visible.sync="editexceldialogVisible" width="50%">


            <!-- 文件上传组件 -->
            <el-upload class="upload-demo" :auto-upload="false" action="#" :on-change="edithandleFileChange"
                :show-file-list="false" accept=".xlsx,.xls,.csv" drag>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将Excel文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">
                    只能上传xlsx/xls文件，且必须包含以下列：<br>
                    dlsname(代理商名称), dlsownerid, dlsapiid, dlsapikey, zownerid
                </div>
            </el-upload>

            <!-- 预览表格 -->
            <el-table v-if="editimportData.length > 0" :data="editimportData" border style="width: 100%; margin-top: 20px;">
                <el-table-column prop="minconsume" label="最小金额"></el-table-column>
                <el-table-column prop="maxconsume" label="最大金额"></el-table-column>
                <el-table-column prop="deeplink" label="账户DP"></el-table-column>

            </el-table>

            <span slot="footer" class="dialog-footer">
                <el-button @click="editexceldialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="editsubmitImportform" :disabled="editimportData.length === 0">
                    确 定 (已导入 {{ editimportData.length }} 条数据)
                </el-button>
            </span>
        </el-dialog>
    </el-container>
</template>

<script>
import axios from "axios";
import * as XLSX from 'xlsx';
import { get } from "babel-register/lib/cache";


export default {
    data() {
        return {
            editimportData: [],
            editexceldialogVisible: false,
            taskLoadingnewplan: false,
            editingtask: [],
            exitingMonitorId: null,
            taskLoading: false,
            multipleSelection: [],
            userId: '',
            total: 0,
            pageNum: 1,
            pageSize: 10,
            pages: 0,
            dialogVisible: false,
            exceldialogVisible: false,
            importData: [], // 存储解析后的数据
            file: null, // 存储上传的文件s
            editfile: null,
            dingxiangbaoData: [],
            regionOptions: [],
            selectedRegions: [],
            checkShow: '',
            input: '',
            creativeMaterials: false,

            loading: false,
            props: {
                value: 'code',
                label: 'name',
                children: 'children',
                multiple: true,
                emitPath: false
            },
            form: {
                status: false,

            },
            form2: {
                monitoruserid: null,
                status: false,
            },


            creativeMaterialsedit: false,
            editform: {
                id: '',
                pkgname: '',
                diyuselectAll: false,
                diyuisIndeterminate: false,
                gender: '',
                selectedAges: ['COMMON'],
                osType: '',
                selectedPhonePrices: [],
                selectedNetworks: [],
                timeType: 'COMMON',
                appPackage: '',
                appPackageValue: '',
                appFilter: '',
                appFilterValue: '',
                regionType: 'COMMON',


            },
            disabledstatus: false
        };
    },
    created() {
        this.userId = this.$route.query.userId

        if (!this.userId) {
            this.$message.warning('您得先登录')
            setTimeout(() => {
                window.location.href = 'https://control.zjwec.cn/page/end/login.html'
            }, 1500)
        }

        this.getdingixnagbaolist()
    },
    watch: {

    },

    methods: {
        downloadTemplate() {
            // 1. 构造表头数据
            const header = [
                ['最小金额', '最大金额', '账户DP']
            ];

            // 2. 创建工作表和工作簿
            const worksheet = XLSX.utils.aoa_to_sheet(header);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, '模板');

            // 3. 写入并生成 Blob
            const excelBuffer = XLSX.write(workbook, {
                bookType: 'xlsx',
                type: 'array'
            });

            // 4. 触发下载
            const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
            saveAs(blob, '代理商模板.xlsx');
        },
        async editdpcheckOverlap(row) {
            const tasklist = this.form2.tasklist;
            const current = tasklist[row];
            const res = await axios.put('https://control.zjwec.cn/oppo/oppoMonitorPlanTasks/update', {
                ...current
            }).then((res) => {


                if (res.data.code == 0) {
                    this.$message.success(`第 ${row + 1} 行已更新`);
                } else {
                    console.error(`第 ${index + 1} 行更新失败：`, err);
                    this.$message.error(`第 ${row + 1} 行更新失败`);
                }
            }).catch(err => {
                console.error(`第 ${index + 1} 行更新失败：`, err);
                this.$message.error(`第 ${row + 1} 行更新失败`);
            });
        },
        async removeAccountRow(index, row) {


            // 如果 row.id 存在（有效ID）
            if (row.id) {
                try {
                    // 调用删除接口
                    const response = await axios.delete(`https://control.zjwec.cn/oppo/oppoMonitorPlanTasks/delete/${row.id}`,);

                    // 根据响应结果处理

                    if (response.data.code == 0) {

                        this.form2.tasklist.splice(index, 1);
                        this.$message.success("删除成功");
                    } else {
                        console.error("后端删除失败，保留数据");
                        this.$message.error("删除失败，请重试");
                    }
                } catch (error) {
                    console.error("删除请求失败:", error);
                    this.$message.error("删除请求失败: " + error.message);
                }
            }
            // 如果 row.id 不存在（新增未提交的行）
            else {
                this.$message.success("删除成功");

                this.form2.tasklist.splice(index, 1);
            }
        },
        async newplanremoveAccountRow(index, row) {

            this.form.tasklist.splice(index, 1);
            this.$message.success("删除成功");

        },
        async checkOverlap(index) {
            const tasklist = this.form2.tasklist;
            const current = tasklist[index];

            let currentMin = current.minconsume !== '' ? Number(current.minconsume) : null;
            let currentMax = current.maxconsume !== '' ? Number(current.maxconsume) : null;


            if ((currentMin !== null && isNaN(currentMin)) || (currentMax !== null && isNaN(currentMax))) return;

            const checkDecimal = val => {
                const str = String(val);
                return str.includes('.') && str.split('.')[1].length > 2;
            };


            if (currentMin !== null && checkDecimal(current.minconsume)) {
                this.$message.warning(`第 ${index + 1} 行：最小金额最多保留两位小数，已清空`);
                current.minconsume = '';
                return;
            }

            if (currentMax !== null && checkDecimal(current.maxconsume)) {
                this.$message.warning(`第 ${index + 1} 行：最大金额最多保留两位小数，已清空`);
                current.maxconsume = '';
                return;
            }

            if (currentMin !== null && currentMax !== null && currentMin > currentMax) {
                this.$message.warning(`第 ${index + 1} 行：最小金额不能大于最大金额`);
                return;
            }

            if (currentMin === null || currentMax === null) return;

            for (let i = 0; i < tasklist.length; i++) {
                if (i === index) continue;

                const item = tasklist[i];
                const min = item.minconsume !== '' ? Number(item.minconsume) : null;
                const max = item.maxconsume !== '' ? Number(item.maxconsume) : null;

                if (min === null || max === null || isNaN(min) || isNaN(max)) continue;


                const isOverlap = !(currentMax <= min || currentMin >= max);
                if (isOverlap) {
                    this.$message.warning(`第 ${index + 1} 行区间与第 ${i + 1} 行重叠，已自动清除冲突字段`);

                    if (currentMin < max && currentMin > min) {
                        current.minconsume = '';
                    }
                    if (currentMax > min && currentMax < max) {
                        current.maxconsume = '';
                    }

                    return;
                }
            }


            if (current.id) {
                try {
                    await axios.put('https://control.zjwec.cn/oppo/oppoMonitorPlanTasks/update', {
                        ...current
                    });

                    this.$message.success(`第 ${index + 1} 行已更新`);
                } catch (err) {

                    this.$message.error(`第 ${index + 1} 行更新失败`);
                }
            }
        },
        excelopenDialog() {
            this.exceldialogVisible = true;
            this.importData = []; // 清空之前的数据
            this.file = null;
        },
        editexcelopenDialog() {
            this.editexceldialogVisible = true;
            this.editimportData = []; // 清空之前的数据
            this.file = null;
        },
        async newplancheckOverlap(index) {
            const tasklist = this.form.tasklist;
            const current = tasklist[index];

            const currentMin = current.minconsume !== '' ? Number(current.minconsume) : null;
            const currentMax = current.maxconsume !== '' ? Number(current.maxconsume) : null;

            if ((currentMin !== null && isNaN(currentMin)) || (currentMax !== null && isNaN(currentMax))) return;

            if (currentMin !== null && currentMax !== null && currentMin > currentMax) {
                this.$message.warning(`第 ${index + 1} 行：最小金额不能大于最大金额`);
                return;
            }

            if (currentMin === null || currentMax === null) return;

            for (let i = 0; i < tasklist.length; i++) {
                if (i === index) continue;

                const item = tasklist[i];
                const min = item.minconsume !== '' ? Number(item.minconsume) : null;
                const max = item.maxconsume !== '' ? Number(item.maxconsume) : null;

                if (min === null || max === null || isNaN(min) || isNaN(max)) continue;

                const isOverlap = !(currentMax < min || currentMin > max);
                if (isOverlap) {
                    this.$message.warning(`第 ${index + 1} 行区间与第 ${i + 1} 行重叠，已自动清除冲突字段`);

                    if (currentMin <= max && currentMin >= min) {
                        current.minconsume = '';
                    }
                    if (currentMax >= min && currentMax <= max) {
                        current.maxconsume = '';
                    }

                    return;
                }
            }


            if (current.id) {
                const res = await axios.put('https://control.zjwec.cn/oppo/oppoMonitorPlanTasks/update', {
                    ...current
                }).then((res) => {
                    if (res.data.code == 0) {
                        this.$message.success(`第 ${index + 1} 行已更新`);
                    } else {
                        console.error(`第 ${index + 1} 行更新失败：`, err);
                        this.$message.error(`第 ${index + 1} 行更新失败`);
                    }


                }).catch(err => {
                    console.error(`第 ${index + 1} 行更新失败：`, err);
                    this.$message.error(`第 ${index + 1} 行更新失败`);
                });
            }
        }



        ,
        addTaskRow() {
            const first = this.form2.tasklist[0];
            if (this.form2.tasklist.length == 0 || first &&
                (first.minconsume !== '' && first.minconsume !== null && first.minconsume !== undefined) &&
                first.maxconsume !== '' &&
                first.deeplink !== '') {
                this.form2.tasklist.unshift({
                    planid: null,
                    minconsume: '',
                    maxconsume: '',
                    deeplink: ""
                })
            } else {
                this.$message.warning('任务信息不完整，无法添加');
                return
            }

        },
        newplanaddTaskRow() {
            const first = this.form.tasklist[0];
            if (this.form.tasklist.length == 0 || first &&
                (first.minconsume !== '' && first.minconsume !== null && first.minconsume !== undefined) &&
                first.maxconsume !== '' &&
                first.deeplink !== '') {
                this.form.tasklist.unshift({
                    planid: null,
                    minconsume: '',
                    maxconsume: '',
                    deeplink: ""
                })
            } else {
                this.$message.warning('任务信息不完整，无法添加');
                return
            }

        },

        deleteSelected() {
            if (this.multipleSelection.length === 0) return;

            this.$confirm(
                `确定删除选中的 ${this.multipleSelection.length} 条记录吗？`,
                '批量删除',
                { type: 'warning' }
            ).then(() => {
                const deleteList = this.multipleSelection.map(item => (item.id));
                axios.post('https://control.zjwec.cn/oppo/monitor/deleteBatch', deleteList)
                    .then(res => {

                        if (res.data.code == 0) {

                            this.$message.success('删除成功');
                            this.getdingixnagbaolist();              // 重新拉取表格数据
                            this.$refs.multipleTable.clearSelection(); // 清除选中状态
                        } else {
                            this.$message.error('提交失败: ' + (err.response.data.message || err.message));
                            console.error(err);
                        }
                    })
                    .catch(err => {
                        this.$message.error('提交失败: ' + (err.response.data.message || err.message));
                        console.error(err);
                    });
            });
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        async opendialog() {
            this.creativeMaterials = true;
            this.form = {
                name: '',
                status: 0,
                userid: '',
                monitoruserid: ''
            }
            const res = await axios.get(`https://control.zjwec.cn/oppo/monitor/listByUserId`, {
                params: { userid: this.userId }
            });

            this.form = { ...this.form, monitoruseridlist: res.data.data, tasklist: [] }
            // this.form2 = {}
        },

        // 文件选择变化时触发
        handleFileChange(file) {
            const isExcel = file.name.endsWith('.xlsx') ||
                file.name.endsWith('.xls') ||
                file.name.endsWith('.csv');

            if (!isExcel) {
                this.$message.error('只能上传Excel文件!');
                return;
            }

            this.file = file;
            this.parseExcel(file.raw);
        },
        edithandleFileChange(file) {
            const isExcel = file.name.endsWith('.xlsx') ||
                file.name.endsWith('.xls') ||
                file.name.endsWith('.csv');

            if (!isExcel) {
                this.$message.error('只能上传Excel文件!');
                return;
            }

            this.editfile = file;
            this.parseExceledit(file.raw);
        },
        parseExceledit(file) {
            const reader = new FileReader();

            reader.onload = (e) => {
                try {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
                    const firstSheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[firstSheetName];

                    // 将工作表转换为JSON
                    const jsonData = XLSX.utils.sheet_to_json(worksheet);

                    // 检查Excel列名是否匹配
                    const requiredColumns = ['最小金额', '最大金额', '账户DP'];
                    const actualColumns = Object.keys(jsonData[0] || {});

                    const missingColumns = requiredColumns.filter(col => !actualColumns.includes(col));
                    if (missingColumns.length > 0) {
                        throw new Error(`缺少必要列: ${missingColumns.join(', ')}`);
                    }

                    // 转换数据格式并检查区间冲突
                    const importData = [];
                    const conflicts = []; // 存储冲突信息

                    jsonData.forEach((item, index) => {
                        const minconsume = (item['最小金额'] !== undefined && item['最小金额'] !== null)
                            ? Number(item['最小金额'])
                            : null;

                        const maxconsume = (item['最大金额'] !== undefined && item['最大金额'] !== null)
                            ? Number(item['最大金额'])
                            : null;

                        const deeplink = item['账户DP'];

                        // 验证数值有效性
                        if ((minconsume !== null && isNaN(minconsume)) || (maxconsume !== null && isNaN(maxconsume))) {
                            conflicts.push({
                                row: index + 2, // Excel行号从1开始，表头占1行
                                message: '包含非数字值'
                            });
                            return;
                        }

                        // 检查最小金额不大于最大金额
                        if (minconsume !== null && maxconsume !== null && minconsume > maxconsume) {
                            conflicts.push({
                                row: index + 2,
                                message: '最小金额大于最大金额'
                            });
                            return;
                        }

                        // 检查区间冲突
                        if (minconsume !== null && maxconsume !== null) {
                            for (const existing of importData) {
                                if (existing.minconsume !== null && existing.maxconsume !== null) {
                                    const isOverlap = !(maxconsume < existing.minconsume || minconsume > existing.maxconsume);
                                    if (isOverlap) {
                                        conflicts.push({
                                            row: index + 2,
                                            message: `与第${existing.row}行区间重叠`,
                                            conflictWith: existing.row
                                        });
                                        break;
                                    }
                                }
                            }
                        }

                        // 如果没有冲突，添加到导入数据
                        if (!conflicts.some(c => c.row === index + 2)) {
                            importData.push({
                                row: index + 2, // 记录原始行号

                                minconsume: minconsume !== null ? minconsume.toString() : '',
                                maxconsume: maxconsume !== null ? maxconsume.toString() : '',
                                deeplink: deeplink
                            });
                        }
                    });

                    this.editimportData = importData;

                    // 显示处理结果
                    if (conflicts.length > 0) {
                        const conflictMessages = conflicts.map(c =>
                            `第${c.row}行: ${c.message}${c.conflictWith ? ` (与第${c.conflictWith}行冲突)` : ''}`
                        ).join('\n');

                        this.$message.warning({
                            message: `发现 ${conflicts.length} 处冲突:\n${conflictMessages}`,
                            duration: 10000 // 显示10秒
                        });

                        // 也可以将冲突信息保存到组件数据中，供UI显示
                        this.conflictData = conflicts;
                    }

                    this.$message.success(`成功解析 ${importData.length} 条有效数据`);

                } catch (error) {
                    this.$message.error('解析Excel文件失败: ' + error.message);
                    console.error('解析错误:', error);
                }
            };

            reader.readAsArrayBuffer(file);
        }
        ,
        // 解析Excel文件
        parseExcel(file) {
    const reader = new FileReader();

    reader.onload = (e) => {
        try {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];

            // 将工作表转换为JSON
            const jsonData = XLSX.utils.sheet_to_json(worksheet);

            // 检查Excel列名是否匹配
            const requiredColumns = ['最小金额', '最大金额', '账户DP'];
            const actualColumns = Object.keys(jsonData[0] || {});

            const missingColumns = requiredColumns.filter(col => !actualColumns.includes(col));
            if (missingColumns.length > 0) {
                throw new Error(`缺少必要列: ${missingColumns.join(', ')}`);
            }

            // 转换数据格式并检查区间冲突
            const importData = [];
            const conflictRows = new Set(); // 使用Set记录冲突行号

            // 第一遍：收集所有有效数据
            const allValidItems = jsonData
                .map((item, index) => {
                    const rowNum = index + 2;
                    const min = item['最小金额'] !== undefined && item['最小金额'] !== null 
                        ? Number(item['最小金额']) 
                        : null;
                    const max = item['最大金额'] !== undefined && item['最大金额'] !== null 
                        ? Number(item['最大金额']) 
                        : null;
                    const deeplink = item['账户DP'];

                    // 验证基本有效性
                    if (min === null || max === null || isNaN(min) || isNaN(max)) {
                        conflictRows.add(rowNum);
                        return null;
                    }

                    if (min > max) {
                        conflictRows.add(rowNum);
                        return null;
                    }

                    return { row: rowNum, min, max, deeplink };
                })
                .filter(item => item !== null);

            // 第二遍：检测区间冲突
            const sortedItems = [...allValidItems].sort((a, b) => a.min - b.min);
            
            for (let i = 0; i < sortedItems.length; i++) {
                const current = sortedItems[i];
                let hasConflict = false;

                // 只需要检查后面的项目（因为已排序）
                for (let j = i + 1; j < sortedItems.length; j++) {
                    const other = sortedItems[j];
                    
                    // 如果当前项目的max >= 下一个项目的min，说明有重叠
                    if (current.max >= other.min) {
                        conflictRows.add(current.row);
                        conflictRows.add(other.row);
                        hasConflict = true;
                    } else {
                        // 由于已排序，后面的项目min会更大，可以提前结束
                        break;
                    }
                }

                // 如果没有冲突则加入最终数据
                if (!hasConflict && !conflictRows.has(current.row)) {
                    importData.push({
                        row: current.row,
                        minconsume: current.min.toString(),
                        maxconsume: current.max.toString(),
                        deeplink: current.deeplink
                    });
                }
            }

            this.importData = importData;

            // 显示处理结果
            if (conflictRows.size > 0) {
                const conflictList = Array.from(conflictRows).sort((a, b) => a - b);
                const conflictMessages = conflictList.map(rowNum => 
                    `第${rowNum}行: 存在区间冲突`
                ).join('\n');

                this.$message.warning({
                    message: `发现 ${conflictRows.size} 处冲突，已自动过滤:\n${conflictMessages}`,
                    duration: 10000
                });
            }

            this.$message.success(`成功解析 ${importData.length} 条有效数据`);

        } catch (error) {
            this.$message.error('解析Excel文件失败: ' + error.message);
            console.error('解析错误:', error);
        }
    };

    reader.readAsArrayBuffer(file);
}
        ,
        async editsubmitImportform() {
            try {
                // 检查是否有导入数据
                if (!this.editimportData || this.editimportData.length === 0) {
                    this.$message.warning('没有可导入的数据');
                    return;
                }

                // 准备要添加的任务数据
                const tasksToAdd = this.editimportData
                    .filter(item => item.minconsume && item.maxconsume && item.deeplink)
                    .map(item => ({
                        minconsume: Number(item.minconsume),
                        maxconsume: Number(item.maxconsume),
                        deeplink: item.deeplink,
                    }));

                if (tasksToAdd.length === 0) {
                    this.$message.warning('没有有效的任务数据可添加');
                    return;
                }

                // 检查金额区间冲突（包括现有任务）
                const allTasks = [...this.form2.tasklist, ...tasksToAdd];
                const conflicts = this.checkConsumeConflicts(allTasks);

                if (conflicts.length > 0) {
                    const conflictMsg = conflicts.map(c =>
                        `区间 ${c.min}-${c.max} 与第${c.conflictRow}行冲突`
                    ).join('\n');

                    this.$message.error({
                        message: `发现 ${conflicts.length} 处金额区间冲突:\n${conflictMsg}`,
                        duration: 10000
                    });
                    return;
                }

                // 将验证通过的任务添加到现有任务列表
                this.form2.tasklist = [...this.form2.tasklist, ...tasksToAdd];
                this.$message.success(`成功添加 ${tasksToAdd.length} 条任务`);

                // 清空导入数据
                this.editimportData = [];
                this.editexceldialogVisible = false
            } catch (error) {
                // console.error('添加任务失败:', error);
                this.$message.error('添加任务失败: ' + (error.response.data.message || error.message));
            }
        },
        async submitImportform() {
            try {
                // 检查是否有导入数据
                if (!this.importData || this.importData.length === 0) {
                    this.$message.warning('没有可导入的数据');
                    return;
                }

                // 准备要添加的任务数据
                const tasksToAdd = this.importData
                    .filter(item => item.minconsume && item.maxconsume && item.deeplink)
                    .map(item => ({
                        minconsume: Number(item.minconsume),
                        maxconsume: Number(item.maxconsume),
                        deeplink: item.deeplink,
                    }));

                if (tasksToAdd.length === 0) {
                    this.$message.warning('没有有效的任务数据可添加');
                    return;
                }

                // 检查金额区间冲突（包括现有任务）
                const allTasks = [...this.form.tasklist, ...tasksToAdd];
                const conflicts = this.checkConsumeConflicts(allTasks);

                if (conflicts.length > 0) {
                    const conflictMsg = conflicts.map(c =>
                        `区间 ${c.min}-${c.max} 与第${c.conflictRow}行冲突`
                    ).join('\n');

                    this.$message.error({
                        message: `发现 ${conflicts.length} 处金额区间冲突:\n${conflictMsg}`,
                        duration: 10000
                    });
                    return;
                }

                // 将验证通过的任务添加到现有任务列表
                this.form.tasklist = [...this.form.tasklist, ...tasksToAdd];
                this.$message.success(`成功添加 ${tasksToAdd.length} 条任务`);

                // 清空导入数据
                this.importData = [];
                this.exceldialogVisible = false
            } catch (error) {
                console.error('添加任务失败:', error);
                this.$message.error('添加任务失败: ' + (error.response.data.message || error.message));
            }
        },
        async submitImport() {
            try {
                if (!this.form.name) {
                    this.$message.warning('请输入计划名称');
                    return;
                }

                // 1. 创建监控计划
                const res = await axios.post('https://control.zjwec.cn/oppo/oppoMonitorPlan/create', {
                    status: this.form.status,
                    name: this.form.name,
                    monitoruserid: this.form.monitoruserid,
                    userid: this.userId
                });

                if (res.data.code != 0) {
                    throw new Error(res.data.message || '创建监控计划失败');
                }

                const planId = res.data.data;

                // 2. 获取有效任务并按最小金额排序
                const validTasks = this.form.tasklist
                    .filter(item =>
                        item.minconsume !== '' &&
                        !isNaN(Number(item.minconsume)) &&
                        item.maxconsume !== '' &&
                        !isNaN(Number(item.maxconsume)) &&
                        item.deeplink !== ''
                    )
                    .map(item => ({
                        ...item,
                        minconsume: Number(item.minconsume),
                        maxconsume: Number(item.maxconsume),
                        planid: planId
                    }))
                    .sort((a, b) => a.minconsume - b.minconsume);

                if (validTasks.length === 0) {
                    this.$message.warning('没有有效的任务数据');
                    return;
                }

                // 3. 自动调整金额区间（使连续）
                const adjustedTasks = this.makeRangesContinuous(validTasks);

                // 4. 提交调整后的任务
                const res2 = await axios.post(
                    'https://control.zjwec.cn/oppo/oppoMonitorPlanTasks/batch',
                    adjustedTasks
                );

                if (res2.data.code == 0) {
                    this.$message.success('提交成功');
                    this.resetForm();
                    this.getdingixnagbaolist();
                } else {
                    throw new Error(res2.data.message || '任务提交失败');
                }

            } catch (error) {
                console.error('提交失败:', error);
                this.$message.error('提交失败: ' + error.message);
            }
        },
        resetForm() {
            this.form = {
                status: '',
                name: '',
                monitoruserid: '',
                tasklist: []
            };
            this.creativeMaterials = false;
        },

        // 使金额区间连续的方法
        makeRangesContinuous(tasks) {
            if (tasks.length <= 1) return tasks;

            const adjustedTasks = [...tasks];

            // 从第二个区间开始调整
            for (let i = 1; i < adjustedTasks.length; i++) {
                const prev = adjustedTasks[i - 1];
                const current = adjustedTasks[i];

                // 如果前一个区间的结束不等于当前区间的开始
                if (prev.maxconsume !== current.minconsume) {
                    // 调整前一个区间的结束值为当前区间的开始值
                    prev.maxconsume = current.minconsume;
                }
            }

            return adjustedTasks;
        },

        // 检查金额区间冲突的方法（保持不变）
        checkConsumeConflicts(tasks) {
            const conflicts = [];
            console.log('检查冲突的任务列表:', tasks);

            // 检查每对任务是否有冲突
            for (let i = 0; i < tasks.length; i++) {
                const current = tasks[i];

                // 确保金额是数字
                if (isNaN(current.minconsume) || isNaN(current.maxconsume)) {
                    conflicts.push({
                        row: i + 1,
                        min: current.minconsume,
                        max: current.maxconsume,
                        message: '包含无效的金额值'
                    });
                    continue;
                }

                // 检查最小不大于最大
                if (current.minconsume > current.maxconsume) {
                    conflicts.push({
                        row: i + 1,
                        min: current.minconsume,
                        max: current.maxconsume,
                        message: '最小金额大于最大金额'
                    });
                    continue;
                }

                // 检查与其他任务的冲突
                for (let j = i + 1; j < tasks.length; j++) {
                    const other = tasks[j];

                    if (isNaN(other.minconsume) || isNaN(other.maxconsume)) continue;

                    // 修改后的冲突检测逻辑 - 允许相邻区间
                    const isOverlap = current.maxconsume > other.minconsume && current.minconsume < other.maxconsume;
                    if (isOverlap) {
                        conflicts.push({
                            row: i + 1,
                            conflictRow: j + 1,
                            min: current.minconsume,
                            max: current.maxconsume,
                            message: `与第${j + 1}行区间重叠`
                        });
                        break;
                    }
                }
            }

            console.log('发现的冲突:', conflicts);
            return conflicts;
        },
        async selectdxb() {

            try {
                // 调用删除接口
                const res = await axios.get('https://control.zjwec.cn/oppo/oppoMonitorPlan/page', {
                    params: { pageNum: this.pageNum, pageSize: this.pageSize, name: this.input, userid: this.userId, } // 替换为你的参数
                }).then(res => {
                    // if(res.data)

                    if (res.data.code < 0) {
                        this.$message.error('查询失败: ' + res.data.msg);
                        return
                    }

                    this.dingxiangbaoData = res.data.data.records
                    this.$message.success('查询成功');
                });

            } catch (error) {
                console.error('查询失败:', error);
                this.$message.error('查询失败: ' + res.data.msg);
            }
        },
        async editdxbao(params) {
            this.creativeMaterialsedit = true
            console.log(params);
            this.exitingMonitorId = params.monitoruserid; // 保存当前的 monitoruserid
            // console.log(params);
            this.form2 = { ...params }
            const res = await axios.get(`https://control.zjwec.cn/oppo/monitor/listByUserId`, {
                params: { userid: this.userId }
            });

            const res2 = await axios.get(`https://control.zjwec.cn/oppo/oppoMonitorPlanTasks/byPlan/${params.id}`);

            this.form2 = { ...this.form2, monitoruseridlist: res.data.data, tasklist: res2.data.data }

        },
        async deletedxb(row) {

            try {
                // 调用删除接口
                const res = await axios.delete(`https://control.zjwec.cn/oppo/oppoMonitorPlan/delete/${row.id}`, {
                    // params: { id: row.id } // 替换为你的参数
                    // id: row.id
                });

                if (res.data.code == 0) {
                    this.$message.success('删除成功');
                    this.getdingixnagbaolist()
                } else {
                    console.error('删除失败:', error);
                    this.$message.error('删除失败: ');
                    this.getdingixnagbaolist()
                }


                // this.$emit('deleted'); // 触发事件通知父组件
            } catch (error) {
                console.error('删除失败:', error);
                this.$message.error('删除失败: ');
                this.pageNum = 1
                this.getdingixnagbaolist()
            }
        },
        getdingixnagbaolist() {
            axios.get('https://control.zjwec.cn/oppo/oppoMonitorPlan/page', { params: { pageNum: this.pageNum, pageSize: this.pageSize, userid: this.userId } }).then(res => {

                this.dingxiangbaoData = res.data.data.records

                this.total = res.data.data.total
                // this.pageSize=res.data.data.pages
                this.pageNum = res.data.data.current

            })
        },
        closebiaodan() {
            this.form = {
                dlsname: '',
                dlsownerid: '',
                dlsapiid: '',
                dlsapikey: '',
                zownerid: '',
                media: "oppo",
                userid: '',
            }


        },
        closebiaodanedit() {
            this.creativeMaterialsedit = false
        },

        async postdingxiang2() {
    try {
        // 1. 检查并处理解绑逻辑（保持不变）
        if (this.form2.monitoruserid && this.exitingMonitorId !== this.form2.monitoruserid) {
            try {
                const res = await axios.get('https://control.zjwec.cn/oppo/oppoMonitorPlan/listByMonitorId', {
                    params: { monitoruserid: this.form2.monitoruserid }
                });

                if (res.data.data.length > 0) {
                    const isConfirm = await this.$confirm(
                        `您选择的子账户已绑定在"${res.data.data[0].name}"计划下，确定解绑吗？`,
                        '解绑确认',
                        {
                            confirmButtonText: '确认解绑',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }
                    ).catch(() => false);

                    if (!isConfirm) return;

                    await axios.put('https://control.zjwec.cn/oppo/oppoMonitorPlan/update', {
                        id: res.data.data[0].id,
                        monitoruserid: null,
                        ...res.data.data[0]
                    });
                }
            } catch (error) {
                console.error('解绑操作失败:', error);
                this.$message.error('解绑操作失败');
                return;
            }
        }

        // 2. 准备任务数据（修复0值问题）
        const validTasks = this.form2.tasklist
            .filter(item => 
                item.deeplink && 
                !isNaN(Number(item.minconsume)) && 
                !isNaN(Number(item.maxconsume))
            )
            .map(item => ({
                ...item,
                minconsume: Number(item.minconsume),
                maxconsume: Number(item.maxconsume)
            }))
            .sort((a, b) => a.minconsume - b.minconsume);

        // 3. 调整区间为连续（修复单条记录问题）
        const adjustedTasks = validTasks.length > 1 
            ? this.adjustRangesToContinuous(validTasks)
            : validTasks;

        // 4. 更新计划信息
        const updateRes = await axios.put('https://control.zjwec.cn/oppo/oppoMonitorPlan/update', {
            id: this.form2.id,
            name: this.form2.name,
            status: this.form2.status,
            userid: this.form2.userid,
            monitoruserid: this.form2.monitoruserid
        });

        if (updateRes.data.code != 0) {
            throw new Error(updateRes.data.message || '更新计划失败');
        }

        // 5. 提交任务（修复planid赋值）
        const tasksToSubmit = adjustedTasks.map(item => ({
            ...item,
            planid: this.form2.id
        }));

        const batchRes = await axios.post(
            'https://control.zjwec.cn/oppo/oppoMonitorPlanTasks/batch', 
            tasksToSubmit
        );

        if (batchRes.data.code == 0) {
            this.$message.success('操作成功');
            this.resetForm2();
            this.getdingixnagbaolist();
        } else {
            throw new Error(batchRes.data.message || '提交任务失败');
        }

    } catch (error) {
        console.error('操作失败:', error);
        this.$message.error(`操作失败: ${error.response.data.message || error.message}`);
    }
},

// 修复后的区间调整方法
adjustRangesToContinuous(tasks) {
    const adjusted = [...tasks];
    
    // 从第二个任务开始调整
    for (let i = 1; i < adjusted.length; i++) {
        // 确保前一个任务的max等于当前任务的min
        if (adjusted[i-1].maxconsume !== adjusted[i].minconsume) {
            adjusted[i-1].maxconsume = adjusted[i].minconsume;
        }
        
        // 特殊处理：如果调整后导致前一个区间无效（min > max）
        if (adjusted[i-1].minconsume > adjusted[i-1].maxconsume) {
            // 恢复原始值并抛出错误
            adjusted[i-1].maxconsume = tasks[i-1].maxconsume;
            throw new Error(`无法自动调整区间：第${i}个任务(${tasks[i].minconsume}-${tasks[i].maxconsume})与前一任务不兼容`);
        }
    }
    
    return adjusted;
},

// 重置表单
resetForm2() {
    this.form2 = {
        id: '',
        name: '',
        status: '',
        userid: '',
        monitoruserid: '',
        tasklist: [],
        // 其他字段...
    };
    this.creativeMaterialsedit = false;
},
        switchonchange(value) {
            if (!this.form.monitoruserid) {
                this.$message.warning('您得先选择子账户');

                // 恢复原来的状态（撤销这次切换）
                this.form.status = value ? 0 : 1;
                return;
            }

            // 如果合法，就保留用户选择的值
            this.form.status = value ? 1 : 0;

            // 可选：提交修改逻辑
            // this.updateStatus(this.form)
        },

        handleCurrentChange(val) {

            axios.get('https://control.zjwec.cn/oppo/oppoMonitorPlan/page', { params: { pageNum: val, pageSize: this.pageSize, userid: this.userId } }).then(res => {

                this.dingxiangbaoData = res.data.data.records
                this.total = res.data.data.total
            })
        },
        swtichonchange2(value) {

            if (!this.form2.monitoruserid) {
                this.$message.warning('您得先选择子账户')
                return
            }
            this.form2 = { ...this.form2, status: value ? 1 : 0 }
            // console.log(value);
        },






    },

};
</script>

<style scoped>
.timeRange {
    user-select: none;
    position: relative;
    padding: 10px 0;

    .calendar {
        display: inline-block;
    }

    table {
        width: 100%;
        border-radius: 4px;
        border-spacing: 0;
        table-layout: fixed;
        border-collapse: collapse;

        thead {

            th,
            td {
                height: 30px;
            }

            th {
                padding: 5px 0;

            }

            .weekRow {
                width: 100px;
                min-width: 100px;
                padding: 20px 0
            }
        }

        td,
        th {
            outline: 0;
            border: 1px solid #E3E3E3;
            font-size: 12px;
            text-align: center;
            min-width: 11px;
            line-height: 1.6em;
            min-width: 24px;
        }

        tbody {
            position: relative;
            overflow: hidden;

            td {
                height: 20px !important;
            }
        }

        td.active {
            background: hsl(207, 97%, 49%);
        }
    }

    .table-core {
        line-height: 2.4em;
        border: 1px solid #E3E3E3;
        border-top: 0;
        overflow: hidden;
        padding: 10px;

        .clearfix {
            color: #8A8A8A;
            text-align: left;
            height: 22px;
            line-height: 22px;
            margin: 8px 0;
            display: flex;
            font-size: 12px;

            .clearBtn {
                cursor: pointer;
                color: #5775F9;
                font-size: 14px;
                margin-left: auto;
            }
        }

        ul {
            margin: 0;
            padding: 0;
            list-style: none;

            li {
                display: flex;
                align-items: center;
                line-height: 24px;
                margin-bottom: 8px;
                padding: 4px 0;

                label {
                    display: inline-block;
                    min-width: 60px;
                    color: #475569;
                    text-align: left;
                    font-weight: 500;
                    font-size: 13px;
                }

                span {
                    font-size: 13px;
                    background-color: #f1f5f9;
                    padding: 2px 8px;
                    border-radius: 4px;
                    margin-right: 6px;
                    color: #334155;

                    &::after {
                        display: none;
                    }
                }
            }
        }

    }

    #box {
        background: rgba(241, 1, 85, 0.4);
        pointer-events: none;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999;
    }
}

#box {
    background: rgba(241, 1, 85, 0.4);
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
}




.checkIndex {
    padding: 20px;
    height: 600px;
    overflow: auto;
}

.checkView {
    margin-bottom: 20px;
    border: 1px solid #eee;
    padding: 10px;
    border-radius: 4px;
    display: flex;

}

.address {
    display: inline-block;
    margin-left: 10px;
}

.mobileCehck {
    margin-top: 10px;
}

.select-container {
    width: 100%;
    height: 100%;
    background: #f5f5f5;
}

.plan-container {
    text-align: left;
    padding: 20px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    margin-bottom: 50px;
}

.el-form-item__label {
    margin-right: 50px;
}

.demo-ruleForm {
    max-width: 800px;
}

.el-form-item {
    margin-bottom: 22px;
}

.el-radio-group {
    margin-right: 15px;
}

.el-input {
    width: 280px;
}

.el-icon-info {
    color: #409EFF;
    cursor: pointer;
    font-size: 16px;
}

.el-button {
    margin-right: 10px;
}

.adgroup-container {
    padding: 20px;
    background-color: #fff;
}

.adgroup-form {
    max-width: 1200px;
    margin: 0 auto;
}

.section-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    padding-bottom: 10px;
    /* border-bottom: 1px solid #eee; */
}

.form-tip {
    font-size: 12px;
    color: #999;
    margin-top: 8px;
}

.media-specify-box,
.adslot-specify-box,
.region-custom-box,
.time-custom-box {
    margin-top: 15px;
    padding: 15px;
    background-color: #f9f9f9;
    border-radius: 4px;
}

.region-selection {
    margin-top: 15px;
    max-height: 300px;
    overflow-y: auto;
}

.region-item {
    margin-bottom: 10px;
}

.age-checkbox-group,
.phone-price-group,
.network-group {
    display: inline-block;
    margin-left: 15px;
}


.adgroup-item2 {
    color: #606266;
    line-height: 20px;
    font-size: 12px;
    border-left: 2px solid #606266;
    padding-left: 8px;
    font-family: PingFangSC-Regular;
    margin-top: 40px;
    margin-bottom: 40px;
}

.demo-ruleForm {
    max-width: 1000px;
}

.time-custom-box {
    margin-top: 15px;
    padding: 15px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background-color: #f5f7fa;
}

.status-open {
    color: #67C23A;
    background-color: #f0f9eb;
    padding: 4px 10px;
    border-radius: 12px;
    font-weight: bold;
    display: inline-block;
    min-width: 32px;
    text-align: center;
}

.status-close {
    color: #F56C6C;
    background-color: #fef0f0;
    padding: 4px 10px;
    border-radius: 12px;
    font-weight: bold;
    display: inline-block;
    min-width: 32px;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/oppo/oppojhdj.vue